export default __webpack_public_path__ + "static/why-tecalis_logo-orange-44130301c019c4ec8360e76f52af61e1.png";